import { Component, OnInit } from '@angular/core';

import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';

@Component({
    selector: 'app-radio-display-config',
    templateUrl: './radio-display-config.component.html',
    styleUrls: ['./radio-display-config.component.scss'],
    standalone: false
})
export class RadioDisplayConfigComponent extends BaseControlComponent implements OnInit {

  static componentName = 'RadioDisplayConfigComponent';

  constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

  ngOnInit() {
  }

}
